import { useDispatch, useSelector } from "react-redux";
import { Biscuit } from "../../../../utils";

// eslint-disable-next-line no-unused-vars
const usePricetariffs = ({ currentPrice, setCurrentPrice, select }) => {
  const dispatch = useDispatch();
  const result = useSelector((data) => data.checkInTimes);

  const handleChange = (val) => {
    // remove url filter parameter of preselected location
    if (
      typeof window.__temp_filter_pricetariff_id !== "undefined" &&
      val.value !== Number(window.__temp_filter_pricetariff_id)
    ) {
      delete window.__temp_filter_pricetariff_id;
    }
    if (val === "set") {
      dispatch({
        type: "PERIODS",
        link: `check_in_periods?pricetariff_id=555555555&sort=valid_from&direction=asc`,
        token: Biscuit.get("token"),
      });
    } else {
      setCurrentPrice(val.value);
      dispatch({
        type: "PERIODS",
        link: `check_in_periods?pricetariff_id=${val.value}&sort=valid_from&direction=asc`,
        token: Biscuit.get("token"),
      });
    }
    dispatch({ type: "CLEAR_NEW_PERIODS" });
    dispatch({ type: "CLEAR_PATCHES" });
  };

  return {
    result,
    handleChange,
  };
};

export default usePricetariffs;
